
import QuoteUp from "../../../assets/outline/QuoteUp.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function QuoteUpIcon({ className, dataTestid = "QuoteUpIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <QuoteUp data-testid={dataTestid} className={classes} {...rest} />
  );
}
